export const removeAnchorElement = (str = '') => {
  if (typeof str !== 'string') return str;
  return str.replace(/<\/?a[^>]*>/g, '');
};

export const checkExceededMaxLength = (str = '', maxLength = 125) => {
  if (typeof str !== 'string') return str;
  const trimmedStr = str.trim();
  return trimmedStr.length > maxLength;
};
